<template>
  <blank-card>
    <div>
      <div class="profile">
        <div class="main" v-loading="loading">
          <img
            class="avatar"
            v-if="userInfoList.avatarUrl"
            :src="userInfoList.avatarUrl"
            alt=""
          />
          <img
            class="avatar"
            v-else
            src="@/common/image/profile/profile-bird.svg"
            alt=""
          />
          <div class="member">
            <span class="title">{{
              userInfoList.userName
                ? userInfoList.userName
                : $t('profile.defaultBiosMember')
            }}</span>
            <div
              class="info"
              v-if="userInfoList.position || userInfoList.company"
            >
              <span>{{ userInfoList.position }}</span>
              <span>{{ userInfoList.company }}</span>
            </div>
            <div class="empty" v-else>
              <span>{{ $t('profile.noMemberInfo') }}</span>
            </div>
            <el-button @click="Edit" v-if="!isMobile">
              {{ $t('profile.btnEdit') }}
            </el-button>
          </div>
        </div>
      </div>
      <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
        <el-tab-pane :label="$t('profile.history')" name="first" class="browse">
          <History v-if="userInfoList.email" />
        </el-tab-pane>
        <el-tab-pane
          :label="$t('profile.download')"
          name="second"
          class="download"
        >
          <Download v-if="userInfoList.email" />
        </el-tab-pane>
        <el-tab-pane :label="$t('profile.revise')" name="three" v-if="!isMobile"
          ><Revise v-if="userInfoList.email"
        /></el-tab-pane>
      </el-tabs>
      <Member
        v-if="userInfoList.email"
        :userInfoList="userInfoList"
        :isEdit="isEdit"
        @close="close"
        @updateSucess="updateSucess"
        @uploadSuccess="uploadSuccess"
      />
    </div>
  </blank-card>
</template>

<script lang="ts">
import { defineComponent, ref, onBeforeMount } from 'vue'
import BlankCard from '@/components/blankCard/index.vue'
import History from '@/components/profile/history.vue'
import Download from '@/components/profile/download.vue'
import Member from '@/components/profile/member.vue'
import Revise from '@/components/profile/Revise.vue'
import { getUserInfo } from '@/api/profile'
import { UserInfo } from '@/api/type'
import router from '@/router'
import emitter from '@/utils/bus.js'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default defineComponent({
  components: {
    BlankCard,
    History,
    Download,
    Member,
    Revise,
  },
  setup() {
    const route = useRoute()
    const store = useStore()
    const activeName = ref<string>('first')
    const isEdit = ref<boolean>(false)
    const userInfoList = ref({} as UserInfo)
    const loading = ref<boolean>(false)

    store.commit('isMobile')
    const isMobile = store.state.isMobile

    const Edit = () => {
      if (isMobile) return
      isEdit.value = true
    }
    const close = () => {
      isEdit.value = false
    }
    const updateSucess = () => {
      isEdit.value = false
      asyncGetUserInfo()
    }
    const asyncGetUserInfo = async () => {
      try {
        loading.value = true
        const res = await getUserInfo()
        if (res.status) {
          userInfoList.value = res.data
          localStorage.setItem('avatarUrl', res.data.avatarUrl)
          emitter.emit('avatarUrl', res.data.avatarUrl)
        }
      } catch (err) {
        if (err.errorCode) {
          router.push('/login')
        }
      } finally {
        loading.value = false
      }
    }
    const uploadSuccess = () => {
      asyncGetUserInfo()
    }
    onBeforeMount(() => {
      asyncGetUserInfo()
      if (route.params.tabName === 'three') {
        activeName.value = route.params.tabName
      }
    })
    return {
      route,
      activeName,
      userInfoList,
      Edit,
      isEdit,
      close,
      updateSucess,
      uploadSuccess,
      isMobile,
    }
  },
})
</script>
<style lang="less" scoped>
.profile {
  width: 800px;
  margin: 0 auto;
  .main {
    display: flex;
    justify-content: left;
    margin: 45px 0px 85px 15px;
    .avatar {
      width: 145px;
      height: 145px;
      border-radius: 150px;
      border: 5px solid #f5f5f5;
    }
    .member {
      width: 320px;
      height: 120px;
      margin-left: 55px;
      margin-top: 5px;
      .title {
        height: 32px;
        line-height: 32px;
        font-size: 20px;
        color: #303133;
      }
      .info span {
        display: block;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: rgba(107, 114, 127, 0.6);
      }

      .empty {
        height: 50px;
        line-height: 50px;
        color: #e5e5e5;
      }
      .el-button {
        width: 244px;
        height: 42px;
        color: #fff;
        background: #0ca1bd;
        border: 1px solid #0ca1bd;
        margin-top: 18px;
        font-size: 16px;
      }
    }
  }
}
.demo-tabs {
  width: 800px;
  margin: 0 auto;
  /deep/.el-tabs__content {
    margin-left: 25px;
  }
  /deep/.el-tabs__active-bar {
    display: none;
  }
  /deep/.is-active {
    border-bottom: 6px solid #0ca1bd;
  }
  /deep/.el-tabs__item {
    margin-right: 70px;
    padding-left: 25px !important;
    padding-right: 25px !important;
    font-size: 22px;
    height: 50px;
    line-height: 50px;
    color: #303133;
  }
  /deep/.el-tabs__item:hover {
    color: #000;
  }
}

.mobile-viewport {
  .profile {
    width: 100%;
    .main {
      margin: 15px 0px 0px 15px;
      .avatar {
        width: 80px;
        height: 75px;
      }
      .member {
        margin-left: 20px;
        .el-button {
          width: 200px;
        }
      }
    }
  }
  .demo-tabs {
    width: 100%;
    margin: 0 auto;
    /deep/.el-tabs__content {
      margin-left: 25px;
    }
    /deep/.is-active {
      border-bottom: 2px solid #0ca1bd;
    }
    /deep/.el-tabs__header {
      margin: 0px 10px;
    }

    /deep/.el-tabs__item {
      margin-right: 20px;
      padding-left: 15px !important;
      padding-right: 15px !important;
      font-size: 18px;
      height: 50px;
      line-height: 50px;
      color: #303133;
    }
  }
}
</style>
